export type IShowExternalSourceSearchPopup = (
  formId: string,
  fieldId: string,
  externalSourceId: string,
  title: string,
  fieldSuffix?: string,
  triggerElement?: IjQueryElmOrHtmlElm
) => void;

export function showExternalSourceSearchPopup(
  formId: string,
  fieldId = '',
  externalSourceId: string,
  title: string,
  fieldSuffix = '',
  triggerElement?: IjQueryElmOrHtmlElm
): void {
  const $form = $(`#${formId}`);
  const serializedFormData = $form.serialize();
  const $modal = $('#external-source-modal');
  const $modalTitle = $modal.find('.modal-custom-title');
  const $modalLoading = $modal.find('.loading');
  const $dataContainer = $modal.find('.data-container');
  const postUrl = `${window.actionBaseUrl}external_source_search?externalSourceId=${externalSourceId}&fieldSuffix=${fieldSuffix}`;

  if (triggerElement) {
    window.DexeroCoreApp.lastModalTrigger = triggerElement;
  }

  if (!$modal.length) {
    console.warn('Warning! external-source-modal missing in template files.');
    return;
  }
  // Block form
  window.DexeroCoreApp.blockUI($form);

  // Setup modal
  $modalTitle.empty().text(title);
  $modalLoading.removeClass('hide');
  $dataContainer.empty().addClass('hide');

  // Get external source content
  $.post(postUrl, serializedFormData)
    // Handle response
    .done((responseData) => {
      let cleanResponseData = window.DexeroCoreApp.stripHtmlComments(responseData);
      if (cleanResponseData.trim().startsWith('DexeroCoreApp.selectExternalSourceResult(')) {
        // eslint-disable-next-line no-eval
        eval(cleanResponseData);
      } else if (cleanResponseData.trim().startsWith('{"externalSourceId":')) {
        cleanResponseData = cleanResponseData.replace(/\\\\/g, String.fromCharCode(92));
        cleanResponseData = jQuery.parseJSON(cleanResponseData);
        const { externalSourceId: _externalSourceId, jsonValues } =
          cleanResponseData as any as IDCA.IExternalSource;
        window.DexeroCoreApp.selectExternalSourceResult(
          _externalSourceId,
          jsonValues as any as string,
          true
        );
      } else {
        $modalLoading.addClass('hide');
        $dataContainer.removeClass('hide').append(cleanResponseData);
        $modal.modal('show');
        $modal.on('hidden.bs.modal', () => {
          // Reset modal
          $modalTitle.empty();
          $modalLoading.removeClass('hide');
          $dataContainer.empty().addClass('hide');
        });
      }
    })
    .always(() => {
      // Unblock form
      window.DexeroCoreApp.unblockUI($form);
    });
}
